import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { DropdownFilterComponent } from '@irb/irb-common/components/dropdown-filter/dropdown-filter.component';
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';

@Component({ standalone: false,
  selector: 'irb-underlying-target-cell-renderer',
  templateUrl: './underlying-target-cell-renderer.component.html',
  styleUrls: ['./underlying-target-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class UnderlyingTargetCellRendererComponent implements ICellRendererAngularComp {
  @ViewChild(DropdownFilterComponent) irbDropdown: DropdownFilterComponent;

  params: any;
  
  items: IDropdownItem[] = [
    { name: 'Model %', value: 'MODEL_PERC' },
    { name: 'Specify %', value: 'SPECIFY_PERC' },
  ];
  irbDropdownFilterValue: IDropdownItem = this.items[0];

  constructor() { }

  agInit(params: any) {
    this.params = params;
    this.irbDropdownFilterValue = this.items.find(item => item.value === params.value);
  }

  getItemsForFilter(searchStr: any) {
    this.irbDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, this.items));
  }

  onOptionChange() {
    this.params.setValue(this.irbDropdownFilterValue.value);
  }

  refresh() {
    return true;
  }
}
